<template>
  <header class="header-wrapper">
    <div class="header-inner">
      <div class="header">
        <router-link :to="{name: 'RootComponent'}" class="logo-a"><img class="logo" src="@/assets/image/common/logo.png" alt="訪問支援マッチングサービスアネラ"></router-link>
        <div class="catch-phrase">訪問支援マッチングサービスアネラは全国でご利用いただける障がい児向け訪問型療育マッチングサービスです。<br>お気軽にお問い合わせください。</div>
      </div>
    </div>
    <nav>
      <div class="main">
        <ul>
          <li v-if="getUser() === null">
            <router-link :to="{name: 'MembersRegister'}">
              <i class="fas fa-user"></i>
              <span class="label">新規保護者登録</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'AboutComponent'}">
              <i class="fas fa-leaf"></i>
              <span class="label">訪問支援マッチングサービスアネラとは</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'ContactComponent'}">
              <i class="fas fa-envelope-square"></i>
              <span class="label">お問い合わせ</span>
            </router-link>
          </li>
          <li v-if="getUser() !== null">
            <router-link :to="{name: 'MypageRoot'}" class="mypage">
              <i class="fas fa-user"></i>
              <span class="label">マイページ</span>
            </router-link>
          </li>
        </ul>
      </div>
      
      <p class="login">
        <router-link v-if="getUser() === null" :to="{name: 'LoginComponent', query: {nextPath: currentPath}}">
          <i class="fas fa-sign-in-alt"></i>
          <span class="label">ログイン</span>
        </router-link>
        <a v-else href="/static/page/logout.html">
          <i class="fas fa-sign-in-alt"></i>
          <span class="label">ログアウト</span>
        </a>
      </p>
    </nav>
    <div v-if="updateAvailable" class="update">
      <div class="img">
        <img src="@/assets/image/header/movies_bg_01.png">
      </div>
      <div class="text">
        <a :href="currentPath">訪問支援マッチングサービスアネラをアップデート</a>
      </div>
    </div>
  </header>
</template>

<script>
let currentHtml;

export default {
  data() {
    return {
      updateAvailable: false
    }
  },
  computed: {
    currentPath() {
      // プロトコル部分を削る
      return location.href.replace(/^https?:\/\/.+?\//, "/");
    }
  },
  created() {
    // 更新の確認用
    // 参考:
    // https://marmelab.com/blog/2016/08/29/auto-reload-spa-on-mobile-setinterval.html
    const checkUpdate = async () => {
      // 更新の確認。
      const res = await fetch("/");
      const html = await res.text();
      if (currentHtml === undefined) {
        currentHtml = html;
        return;
      }
      if (html !== currentHtml) {
        this.updateAvailable = true;
      }
    };
    // もう面倒なので5秒毎。TODO: そのうちちゃんと修正したい。
    setInterval(checkUpdate, 5 * 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
p,
ul {
  margin: 0;
}
header.header-wrapper {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 2px 2px #999;
  .header-inner {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
    box-sizing: border-box;
    overflow: hidden;
    img {
      width: 100%;
      vertical-align: bottom;
    }
    .header {
      .logo-a {
        display: block;
        width: 116px;
        float: left;
      }
      .catch-phrase {
        margin: 10px 0 0 10px;
        line-height: 1.5em;
        font-size: 10px;
        float: left;
      }
      .contact {
        align-items: flex-end;
        display: flex;
        margin: 6px 0 0 48px;
        height: 90%;
        color: #9cf;
        font-size: 12px;
        float: left;
        a {
          color: inherit;
        }
        .img-div {
          height: 100%;
          margin-right: 4px;
        }
        .phone-number-business-hours {
          display: flex;
          height: 100%;
          flex-flow: column;
          line-height: 1em;
          .business-hours {
            font-size: 11px;
            margin: 0;
            margin-top: auto;
            margin-bottom: -2px;
            line-height: 1em;
          }
          .phone-number {
            height: 20px;
            line-height: 1em;
            font-size: 20px;
            font-weight: bold;
            a {
              i {
                margin-left: 0.5em;
              }
            }
          }
        }
      }
    }
  }
  > nav {
    width: 100%;
    max-width: 1200px;
    height: 40px;
    margin: 0 auto;
    padding: 0.75em 16px 0.25em;
    box-sizing: border-box;
    line-height: 1.5em;
    overflow: hidden;
    .main {
      float: left;
      ul {
        display: flex;
        li {
          flex: 0 0 auto;
          margin: 0;
          a {
            line-height: 1em;
            color: #666;
            font-size: 16px;
            &.mypage {
              color: #f90;
            }
          }
        }
        li:not(:last-of-type) {
          margin: 0 2em 0 0;
        }
      }
    }
    .login {
      float: right;
      a {
        line-height: 1em;
        color: #666;
        font-size: 16px;
      }
    }
  }
  .update {
    position: fixed;
    display: flex;
    justify-content: center;
    background: white;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    box-shadow: 2px 0 4px red;
    .img {
      margin: auto 0;
      height: 40px;
      img {
        height: 100%;
      }
    }
    .text {
      margin: auto 8px;
      a {
        font-weight: bold;
        color: #f28181;
      }
    }
  }
  @media (max-width: 767px) {
    .header-inner {
      height: 35px;
      padding: 0 8px;
      .header {
        .logo-a {
          width: 72px;
          margin-top: 6px;
        }
        .catch-phrase {
          display: none;
        }
        .contact {
          margin-left: 8px;
          .img-div {
            img {
              height: 25px;
            }
          }
          .phone-number-business-hours {
            .business-hours {
              font-size: 8px;
            }
          }
        }
      }
    }
    > nav {
      height: 35px;
      padding: 0 8px;
      .main {
        ul {
          li {
            a {
              display: block;
              text-align: center;
              i {
                font-size: 24px;
              }
              .label {
                display: block;
                line-height: 1em;
                font-size: 6px;
              }
            }
          }
          li:not(:last-of-type) {
            margin: 0 1em 0 0;
          }
        }
      }
      .login {
        position: absolute;
        top: 12px;
        right: 10px;
        a {
          font-size: 12px;
        }
      }
    }
  }
  @media (max-width: 575px) {
    .header-inner {
      .header {
        .contact {
          .phone-number-business-hours {
            .phone-number {
              a {
                span {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderComponent.vue